module.exports = __webpack_public_path__ + "static/media/image.a3eaec77.svg";